import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, inject, Input, OnChanges, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputNumber, InputNumberModule } from 'primeng/inputnumber';

@Component({
  selector: 'lx-weeks-counter',
  standalone: true,
  imports: [CommonModule, InputNumberModule, FormsModule],
  templateUrl: './weeks-counter.component.html',
  styleUrls: ['./weeks-counter.component.scss'],
})
export class WeeksCounterComponent implements OnChanges, AfterViewInit {
  @Input() min = 0;
  @Input() max: number | undefined;
  @Input() rightButtonDisabled = false;
  @Input() value: number | undefined;
  @Output() valueChanged = new EventEmitter<number>();
  @ViewChild('inputNumberRef') inputNumberComponent: InputNumber;

  weeksSuffix = '';
  private readonly renderer = inject(Renderer2);

  ngAfterViewInit() {
    const inputElement = this.inputNumberComponent?.input?.nativeElement;

    if (inputElement) {
      // Set the readonly attribute on the internal input
      this.renderer.setAttribute(inputElement, 'readonly', 'true');

      // Prevent typing in the input field
      this.renderer.listen(inputElement, 'keydown', (event: KeyboardEvent) => {
        // Allow Tab key to navigate to next element
        if (event.key === 'Tab') {
          return;
        }

        event.preventDefault();
      });
    }
  }

  ngOnChanges({ value }: SimpleChanges): void {
    this.weeksSuffix = this.getWeekSuffix(value?.currentValue);

    if (this.value && this.max && this.value > this.max) {
      setTimeout(() => {
        this.value = this.max;
        this.selectValue(this.value);
      });
      this.weeksSuffix = this.getWeekSuffix(this.value);
    }
  }

  selectValue(weeksValue: number): void {
    this.valueChanged.emit(weeksValue);
  }

  private getWeekSuffix(weeks: number): string {
    return weeks === 1 ? $localize` week` : $localize` weeks`;
  }
}
